import React, { useState, useRef } from "react";
import css from "./index.module.scss";
import RegisterForm from "forms/auth/register";
import DefaultLayout from "layouts/default";

export default function RegisterPage({ }) {
  return <DefaultLayout title="Register | Lazy Prompts" description="Register an account to buy and sell prompts.">
    <section className={`light ${css.signin}`}>
      <div className={css.inner}>
        <RegisterForm/>
      </div>
    </section>

  </DefaultLayout>;
}
